import { useOrgMemberDirectory } from "@/shared/domain/orgs/hooks";

import styles from "./MessageAuthor.module.css";

interface MessageAuthorProps {
  /** User ID of the person who sent the message. */
  userId: string;
  /** Org the thread belongs to, whose members' names label the messages. */
  orgId: string;
  /** Side of the thread the labeled bubble sits on: the viewer's own at the end, another member's at the start. */
  align: "start" | "end";
}

/**
 * The sender's name above a user message in a thread several people wrote in.
 * Every label reads the same cached org-member list, so a thread fetches it
 * once however many messages it labels. A sender who is no longer a member of
 * the org, or has no name, is shown by user ID.
 */
export function MessageAuthor({ userId, orgId, align }: MessageAuthorProps) {
  const memberDirectory = useOrgMemberDirectory(orgId);
  const name = memberDirectory.get(userId)?.name ?? userId;
  return (
    <div className={styles.author} data-align={align}>
      {name}
    </div>
  );
}
